<div class="lib-ui-file-upload">
  <label [ngClass]="labelClassName">{{ label }}</label><br>
  <input type="file" accept="image/png, image/jpeg" #fileInput
         (change)="fileUploadChange()" />
</div>
